import { CMP_PREFIX } from "@/base/constant";
import type { GetProps } from "antd";
import { Form as AntdForm } from "antd";

export type FormProps = GetProps<typeof AntdForm>;
export type FormItemProps = GetProps<typeof AntdForm.Item>;
export type FormListProps = GetProps<typeof AntdForm.List>;
export type FormErrorListProps = GetProps<typeof AntdForm.ErrorList>;
export type { FormInstance as FormInstanceType } from "antd";
export const formPrefixCls = `${CMP_PREFIX}-form`;

export const Form = ({ ...props }: FormProps) => {
  const customizeRequiredMark = (
    label: React.ReactNode,
    { required }: { required: boolean },
  ) => (
    <>
      {label}
      {required && <span className={`${formPrefixCls}-required-mark`}>*</span>}
    </>
  );

  return <AntdForm requiredMark={customizeRequiredMark} {...props} />;
};

export const FormItem = ({ ...props }: FormItemProps) => {
  return <AntdForm.Item {...props} />;
};

export const FormList = ({ ...props }: FormListProps) => {
  return <AntdForm.List {...props} />;
};

export const FormErrorList = ({ ...props }: FormErrorListProps) => {
  return <AntdForm.ErrorList {...props} />;
};
